export default (theme) => ({
    root: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '8px',
        boxSizing: 'border-box',
    },
    filtersContainerLeft: {
        width: 'calc(50% - 1px)',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    filtersContent: {
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
        boxSizing: 'border-box',
        padding: '3px 8px',
        borderRadius: '4px',
    },
    withFilters: {
        '&:hover': {
            backgroundColor: theme.colors.grey[100],
        },
    },
    divider: {
        width: '1px',
        height: '16px',
        backgroundColor: theme.colors.grey[100],
    },
    filtersContainerRight: {
        width: 'calc(50% - 1px)',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '8px',
    },
    filtersPopover: {},
    filtersPopoverItem: {
        padding: '8px 0',
    },
    filtersPopoverDivider: {
        width: '100%',
        height: '1px',
        backgroundColor: theme.colors.grey[100],
        margin: '8px 0px',
    },
});
